<app-menu></app-menu>

<div class="container-flui pt-3">
    <div class="row">
        <!-- LADO ESQUERDO DA TELA -->
        <div class="col-12 col-lg-9">
            <div class="card-info">
                <div class="row">
                    <div class="col-12 col-md-8">
                        <h1 class="titulo">Control PS</h1>
                        <h3 class="subtitulo">Mais eficiência na gestão dos <span>usuários</span> e de seus benefícios.
                            Chega de
                            sistemas antigos e sem usabilidade, agora com o <span>Control PS</span> seu trabalho fica
                            até 3x mais
                            rápido e simplificado.
                            Confira um resumo das informações em nosso <span>Dashboard</span></h3>

                        

                        <app-button textButton="Iniciar" routerLink="/usuarios"></app-button>
                    </div>
                    <div class="col-12 col-md-4">
                        <img src="../../../assets/images/dashboard.png" alt="" width="100%">
                    </div>
                </div>
            </div>


            <div class="row mt-4">

                <!-- CARD ESQUERDA -->
                <div class="col-6">
                    <div class="card-info">
                        <div class="row">
                            <div class="col-8">
                                <p class="texto-card">Total de usuários cadastrados no sistema</p>
                                <p class="numero-card">120</p>
                                <p class="destaque-card">+ 5 adicionados no último mês</p>
                            </div>
                            <div class="col-4">
                                <mat-progress-spinner class="example-margin max-auto color-spinner" mode="determinate"
                                    value="79"></mat-progress-spinner>
                                <p class="info-spinner">79/150</p>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- CARD DIREITA -->
                <div class="col-6">
                    <div class="card-info">
                        <div class="row">
                            <div class="col-8">
                                <p class="texto-card">Total de benefícios cadastrados</p>
                                <p class="numero-card">4</p>
                                <p class="destaque-card">+ 2 adicionados no último mês</p>
                            </div>
                            <div class="col-4">
                                <mat-progress-spinner class="example-margin max-auto color-spinner" mode="determinate"
                                    value="80"></mat-progress-spinner>
                                <p class="info-spinner">4/5</p>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- CARD USUÁRIO CADASTRADO -->
                <div class="col-12 mt-4">
                    <div class="card-info">
                        <h3 class="titulo">Último usuario cadastrado</h3>
                        <hr>
                        <div class="row">
                            <div class="col-1"><mat-icon>accounto_circle</mat-icon></div>
                            <div class="col-1">
                                <p class="texto-p">1</p>
                            </div>
                            <div class="col">
                                <p class="texto-p">Marcelo Piezentini</p>
                            </div>
                            <div class="col">
                                <p class="texto-p">Desenvolvedor FrontEnd</p>
                            </div>
                        </div>
                    </div>
                </div>


            </div>
        </div>
        <!-- LADO DIREITO DA TELA -->
        <div class="col-12 col-lg-3">
            <div class="card-info">
                <div class="container-perfil">
                    <div class="avatar-placeholder" [class.clickable]="!!avatarUrl" (dblclick)="triggerAvatarUpload()">
                        <img *ngIf="avatarUrl; else avatarIcon" [src]="avatarUrl" alt="Foto do usuário">
                        <ng-template #avatarIcon>
                            <mat-icon>photo</mat-icon>
                        </ng-template>
                        <div class="avatar-overlay" *ngIf="avatarUrl">
                            <span>Duplo clique para alterar</span>
                        </div>
                    </div>
                    <button type="button" class="add-photo-btn" *ngIf="!avatarUrl" (click)="triggerAvatarUpload()">
                        <mat-icon>add_a_photo</mat-icon>
                        <span>Adicionar foto</span>
                    </button>
                    <input type="file" #avatarInput accept="image/*" hidden (change)="onAvatarSelected($event)">
                    <p class="upload-feedback" *ngIf="isUploading">Enviando foto...</p>
                    <p class="upload-feedback error" *ngIf="uploadError">{{ uploadError }}</p>
                    <h4>Seja bem vindo</h4>
                    <h5>{{ userName || 'Usuário' }}</h5>
                    <li><mat-icon>location_on</mat-icon>Brasil - São Paulo</li>
                </div>

                <hr class="hr">
                <p>"Um ser humano deve transformar informação em inteligência ou conhecimento. Tendemos a
                        esquecer que nenhum computador jamais fará uma nova pergunta"</p>
                <hr class="hr">

                <li><mat-icon>person</mat-icon>Genrencia usuarios</li>
                <li><mat-icon>loyalty</mat-icon>Adicione benefícios</li>
                <li><mat-icon>format_list_bulleted</mat-icon>Consulte cadastros</li>
                <li><mat-icon>delete</mat-icon>Exclua usuários</li>
            </div>
        </div>

        
    </div>
</div>
